import React from "react";
import {fetchDataEntity} from "../../../../api/entity-data";
import {PostToPbx} from "../../../../api/http-post";
import {GetUserToken} from "../../../../api/token";
import moment from "moment/moment";
import {Button, Col, Form, Layout, Row, Select} from "antd";
import {SortData} from "../../../../api/fn";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import LoadingProcessing from "../../../../components/Common/page/Common/LoadingProcessing";
import Connector from "../../../../redux/connector";

const {Content} = Layout;
const {Option} = Select;

function convertDateFormat_DDMMYYYY(dateIn) {
    let mydate = moment(dateIn, "YYYY-MM-DD").format("DD MMM YYYY");
    return mydate;
}

const format = num => {
    const n = String(num),
        p = n.indexOf('.')
    return n.replace(
        /\d(?=(?:\d{3})+(?:\.|$))/g,
        (m, i) => p < 0 || i < p ? `${m},` : m
    )
}


class ContractMinderDatasetLabourPayrollPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Org: "",
            Companies: [],
            Entities: [],
            FnbCsvInfo: [],

            selectedCompany: "",
            selectedModule: "",
            selectedRecord: {},
            selectedPeriod: "",
            selectedSite: "",

            Data: [],
            isLoading: false,
            component: "list",
            initLoading: false,

            DataPeriod: [],
            DataPayCycle: [],
            DataSite: [],
            DataSavedPayroll: [],

            Results: null,
            showViewDetail: false,
        }

    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.initialReload()
    }
    initialReload = async () => {
        await fetchDataEntity("Entities", "", "", this, undefined, "common/entity/modules/list");

    }
    loadContractInfo = async (selectedModule) => {
        let _this = this;
        let module = this.state.selectedModule;
        let hub = {
            Org: this.state.selectedCompany,
            Module: "contract",
            Ref: selectedModule,
        }

        console.log("loadContractInfo > ", hub)
        let endpoint = "/payroll/contract/fetch-data"
        await PostToPbx(hub, endpoint, async (output) => {
            let data = output.RESULT;
            let tmp = _this.state;
            tmp.DataPeriod = data.TermsPeriod;
            tmp.DataDesignation = data.TermsDesignation;
            tmp.DataPayCycle = data.TermsPayCycle;
            tmp.DataSite = data.TermsSite;
            tmp.DataRate = data.TermsRate;
            tmp.DataRateSpecific = data.TermsRateSpecific;
            tmp.DataSlot = data.TermsSlot;
            tmp.DataSiteDesignation = data.TermsSiteDesignation;
            tmp.DataShift = data.TermsShift;
            tmp.DataCondition = data.TermsCondition;
            _this.setState(tmp);

            console.log("loadInitialData > ", output, " > ", data)
        });
    }
    handleChangeCompany = (value, key) => {
        this.setState({
            [key]: value,
        })
    }
    handleChange = async (e, key) => {
        const value = e.value;
        this.setState({
            [key]: value,
        });

        if (key === "selectedModule") {
            console.log("selected module > ", key, value)
            await this.loadContractInfo(value)
        }

    }
    handleChange2 = (e, ee, key) => {
        const val = e;
        let tmp = this.state;
        tmp[key] = val;
        this.setState(tmp);
    }
    validateSubmitSearch = () => {
        const state = this.state;
        if (state.selectedCompany === "") {
            alert("Validation fail! Please select your company")
            return false
        }
        if (state.selectedModule === "") {
            alert("Validation fail! Please select your project")
            return false
        }
        if (state.selectedPeriod === "") {
            alert("Validation fail! Please select your pay circle")
            return false
        }

        return true
    }
    submitSearch = async () => {
        this.setState({
            isLoading: true,
            Results: null,
        });

        if (!this.validateSubmitSearch()) {
            return
        }

        let hub = {
            Org: this.state.selectedCompany,
            Period: this.state.selectedPeriod,
            Project: this.state.selectedModule,
        }

        console.log("1 -Data--> ", hub)
        let endpoint = "/wage/calculation/hourly"
        await PostToPbx(hub, endpoint, async (output) => {
            let data = output.RESULT;
            this.setState({
                Results: data,
                isLoading: false,
            });
            console.log("-search Data--> ", data)
        });

    }
    renderCompaniesSelection = () => {
        if (this.state.component === "form") {
            return
        }
        let ls = this.state.Companies;
        return (
            <Form.Item
                label={""}
                name={"selectedCompany"}
                rules={[{required: true, message: "Please select your company!"}]}
            >
                <Select
                    style={{width: "100%"}}
                    onChange={(value) => this.handleChangeCompany(value, "selectedCompany")}
                    value={this.state.selectedCompany}
                >
                    {ls.map((record, index) => {
                        return (
                            <Option
                                key={record.CustomerNumber}
                                value={record.CustomerNumber}
                            >
                                {record.Name}
                            </Option>
                        )
                    })}
                </Select>
            </Form.Item>

        )
    }
    renderModules = () => {
        let ls = [];
        let org = this.state.selectedCompany;
        for (let i in this.state.Entities) {
            const row = this.state.Entities[i];

            if (row.org === org) {
                ls.push({
                    key: row.name,
                    val: row.name,
                })
            }
        }
        return (
            <Select
                name={"selectedModule"}
                defaultValue=""
                onChange={(e, ee) => this.handleChange(ee, "selectedModule")}
            >
                {ls.map((record, index) => {
                    return (
                        <Option value={record.key}>{record.val}</Option>
                    )
                })}
            </Select>
        )
    }
    formatDate = (dateIn) => {
        return convertDateFormat_DDMMYYYY(dateIn)
    }
    renderPayCycle = () => {
        let data = this.state.DataPayCycle;
        data = SortData("Period", data)
        let ls = [];
        for (let i in data) {
            let row = data[i];
            const key = row.StartDate + "#" + row.EndDate + "#" + row.Period + "#" + row.PayDate;
            const display = row.Period + ". -> Start: " + this.formatDate(row.StartDate) + " -> End: " + this.formatDate(row.EndDate) +
                " -> Pay date: " + this.formatDate(row.PayDate);
            ls.push({
                key: key,
                val: display
            })
        }
        return (
            <React.Fragment>
                <Form.Item label={"Pay Cycle"} required={true}>
                    <Select
                        name={"selectedPeriod"}
                        defaultValue={this.state.selectedPeriod}
                        value={this.state.selectedPeriod}
                        onChange={(e, ee) => this.handleChange2(e, ee, "selectedPeriod")}
                    >
                        {ls.map((record, index) => {
                            return (
                                <Option value={record.key}>{record.val}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </React.Fragment>
        )
    }
    renderQuickSummary = () => {
        const dataStore = this.state.Results;
        let data = dataStore.Summary;

        const numFormat = (numberIn) => {
            numberIn = parseFloat(numberIn)
            let val = format(numberIn);
            let val2 = val.replace(",", " ");
            return val2
        }
        let roles = {};
        let totalAllEmployee = 0;
        let totalAllWage = 0;
        for (let i in data) {
            let row = data[i];
            let role = row.EmpDesignation;
            roles[role] = true;
            totalAllEmployee++;
            totalAllWage += row.NetPay
        }

        let ls = [];
        let exportData = [];
        for (let role in roles) {
            let totEmp = 0;
            let totWage = 0;
            for (let i in data) {
                let row = data[i];
                if (row.EmpDesignation === role) {
                    totEmp++;
                    totWage += parseFloat(row.NetPay)
                }
            }
            ls.push({
                role: role,
                emp: totEmp,
                wage: totWage
            })
            exportData.push({
                "Designation": role,
                "Employee": totEmp,
                "Wages": totWage
                }
            )
        }

        // Add summary data
        const exportSummary = [
            { Total_Employees: totalAllEmployee, Total_Wage: totalAllWage },
        ];

        const exportToExcel = () => {
            const ws = {};
            // --- Summary Section ---
            // Explicitly set cell values and types
            ws['A1'] = { t: 's', v: 'Total Employees:' };
            ws['B1'] = { t: 'n', v: totalAllEmployee };
            ws['A2'] = { t: 's', v: 'Total Wage:' };
            ws['B2'] = { t: 'n', v:  totalAllWage };

            // --- Table Header ---
            ws['A4'] = { t: 's', v: 'Designation' };
            ws['B4'] = { t: 's', v: 'Employees' };
            ws['C4'] = { t: 's', v: 'Wages' };

            // --- Table Data ---
            const data = []
            for (let i in exportData) {
                const row = exportData[i];
                data.push([
                    row.Designation,row.Employee,row.Wages.toFixed(2),
                ])
            }

            // Start table from row 5
            let startRow = 5;
            data.forEach((row, i) => {
                const r = startRow + i;
                ws[`A${r}`] = { t: 's', v: row[0] };
                ws[`B${r}`] = { t: 'n', v: row[1] };
                ws[`C${r}`] = { t: 'n', v: parseFloat(row[2]).toFixed(2)/*, z: '"R"#,##0.00' */}; // format as currency
            });


            // --- Define range ---
            const endRow = startRow + data.length - 1;
            ws['!ref'] = `A1:C${endRow}`;

            // --- Column widths ---
            ws['!cols'] = [
                { wch: 25 },
                { wch: 15 },
                { wch: 20 },
            ];

            // Step 2: Create workbook and append worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Wage Report');

            // Step 3: Generate and save file
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, 'wage-report.xlsx');
        }
        return (
            <div style={{
                marginTop: -50,
                minWidth: "100%",
                backgroundColor: "#fff",
                padding: 20,
                borderRadius: 10,
                border: "1px solid #e8e8e8",
                boxShadow: "0 2px 12px 0 rgba(0,0,0,.1)",
                marginBottom: 20,
            }}>
                <Row>
                    <Col span={14} style={styles.Row1Col}>Total Employee:</Col>
                    <Col span={10} style={{...styles.Row1Col, textAlign: "right"}}>{totalAllEmployee}</Col>
                </Row>
                <Row>
                    <Col span={14} style={styles.Row1Col}>Total Wage:</Col>
                    <Col span={10}
                         style={{...styles.Row1Col, textAlign: "right"}}>{numFormat(totalAllWage.toFixed(2))}</Col>
                </Row>
                <br/><br/>
                <Row>
                    <Col span={10} style={{...styles.Row1Col, textAlign: "left", color: "#3880ff"}}>Designation</Col>
                    <Col span={4} style={{...styles.Row1Col, textAlign: "center", color: "#3880ff"}}>Employees</Col>
                    <Col span={10} style={{...styles.Row1Col, textAlign: "right", color: "#3880ff"}}>Wages</Col>
                </Row>
                {ls.map(row => {
                    return (
                        <Row>
                            <Col span={10} style={{...styles.Row1Col, textAlign: "left"}}>{row.role}</Col>
                            <Col span={4} style={{...styles.Row1Col, textAlign: "center"}}>{row.emp}</Col>
                            <Col span={10}
                                 style={{...styles.Row1Col, textAlign: "right"}}>R{numFormat(row.wage.toFixed(2))}</Col>
                        </Row>
                    )
                })}

                <Row >
                    <Col span={24} style={{...styles.Row1Col, textAlign: "right",marginTop:40}}>
                        <Button style={{minWidth: "100%"}} type="dashed" danger
                                onClick={() => exportToExcel()}>
                            Export to Excel
                        </Button>&nbsp;&nbsp;
                    </Col>
                </Row>
            </div>
        )

    }

    render() {
        let props = this.props;
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Payroll Labour Dataset Report</Title>
                    <Row gutter={16} style={{marginTop: 20}}>
                        <Col span={12}>
                            <Form.Item
                                label={"Company"}
                            >
                                {this.renderCompaniesSelection()}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={"Project"}
                            >
                                {this.renderModules()}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16} style={{marginTop: -40}}>
                        <Col span={24}>
                            {this.renderPayCycle()}
                        </Col>
                    </Row>
                    <Row gutter={16} style={{marginTop: -10}}>
                        <Col span={24}>
                            <Button style={{minWidth: "100%"}} danger onClick={() => this.submitSearch()}>Search
                            </Button>&nbsp;&nbsp;
                        </Col>
                    </Row>
                    {this.state.Results !== null ?
                        <Row gutter={24} style={{marginTop: 40}}>

                            {this.renderQuickSummary()}

                            {/*<DisplayDataReportSummaryHours
                                dataStore={this.state.Results}
                                payDate={this.getPayDate()}
                                _this={this}
                                payPeriod={this.state.selectedPeriod}
                                org={this.state.selectedCompany}
                                project={this.state.selectedModule}
                                submitSearch={this.submitSearch}
                                submitGeneratePaymentSummary={this.submitGeneratePaymentSummary}
                                submitGeneratePaymentSummaryCsv={this.submitGeneratePaymentSummaryCsv}
                                submitGenerateLabourReport={this.submitGenerateLabourReport}
                                submitGenerateLabourReport2Actual={this.submitGenerateLabourReport2Actual}
                                submitGenerateLabourReport2Calendar={this.submitGenerateLabourReport2Calendar}
                                submitGenerateLabourReportCalendar={this.submitGenerateLabourReportCalendar}
                                submitGenerateTimesheetCalendar={this.submitGenerateTimesheetCalendar}
                                FnbCsvInfo={this.getFnbCsvInfo()}
                            />*/}
                            {/*{!this.hasSavedPayroll().has ?
                                <Row gutter={24} style={{marginTop: 40}}>
                                    <Col span={20} style={styles.payCycleWarningLabel}>
                                        This pay cycle is not saved yet, click on save button
                                    </Col>
                                    <Col span={4} style={styles.payCycleButton}>
                                        <Button style={{minWidth: "100%"}} type="dashed" danger
                                                onClick={() => this.savePayrollEncova()}>
                                            Save payroll
                                        </Button>&nbsp;&nbsp;
                                    </Col>
                                </Row> :
                                <Row gutter={24} style={{marginTop: 40}}>
                                    <Col span={24} style={styles.payCycleSavedLabel}>
                                        Thank you your pay cycle was saved on: {this.hasSavedPayroll().info.orgdatetime}
                                    </Col>
                                </Row>
                            }*/}
                        </Row> : null
                    }
                </div>
                <LoadingProcessing open={this.state.isLoading}/>
            </Page>
        )
    }

}

export default Connector(ContractMinderDatasetLabourPayrollPage);

const styles = {

    Row1: {
        border: "1px solid lightgray"
    },
    Row1Col: {
        border: "1px solid lightgray"
    },

    payCycleButton: {
        color: "red",
        fontSize: 24,
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    },
    payCycleWarningLabel: {
        color: "red",
        fontSize: 24,
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
        alignItems: "center"
    },
    payCycleSavedLabel: {
        color: "green",
        fontSize: 24,
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "row",
        alignItems: "center"
    }
}
